import COLORS from 'constants/colors';

export const VERDICT_STATES = {
  VALID: 'valid',
  INVALID: 'invalid',
  PENDING: 'pending',
  REVIEWING: 'reviewing',
};

export const VIEWING_THRESHOLD = {
  SMALL_MAX: 3,
  SMALL_MIN_VIEWED: 1,
  LARGE_MIN_VIEWED: 2,
};

export const VERDICT_DISPLAY = {
  [VERDICT_STATES.VALID]: {
    label: 'Valid',
    color: COLORS.GREEN_6,
    bgColor: COLORS.GREEN_1,
    borderColor: COLORS.GREEN_6,
    icon: '\u2713',
  },
  [VERDICT_STATES.INVALID]: {
    label: 'Invalid',
    color: COLORS.RED_6,
    bgColor: COLORS.RED_1,
    borderColor: COLORS.RED_6,
    icon: '\u2717',
  },
  [VERDICT_STATES.REVIEWING]: {
    label: 'Reviewing',
    color: COLORS.BLUE_5,
    bgColor: COLORS.BLUE_1,
    borderColor: COLORS.BLUE_3,
    icon: '',
  },
  [VERDICT_STATES.PENDING]: {
    label: 'Pending',
    color: COLORS.COLA,
    bgColor: COLORS.GREY_1,
    borderColor: COLORS.GREY_4,
    icon: '',
  },
};

export const OVERLAY_BG = COLORS.BLACK_T_60;
